"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.style.list': 'Writing Styles',
    'route.style.create': 'Add Writing Style',
    'route.style.edit': 'Edit Writing Style',
    'route.style.preview': 'Preview Writing Style',
};
